import * as React from 'react';
import NumberFormat from 'react-number-format';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import TextareaAutosize from 'react-textarea-autosize';
import { Button, Col, CustomInput, Form, FormFeedback, FormGroup, Input, Row } from 'reactstrap';
import { DateInput } from 'src/components/shared/Input/DateInput';
import { ProjectTypeConfig, ProjectTypeList } from 'src/components/shared/Input/ProjectTypeList';
import { Svg } from 'src/components/shared/Svg';
import { functionalSkillsItems, sectorItems ,technicalSkillsItems } from 'src/config';
import { IUser /* , SectorType */ } from 'src/model';
import { IUpdateUserDto } from 'src/model/dto/user-dto';
import { updateUser } from 'src/services';

interface IProfileEditionProps {
  user: IUser;
  refreshUser: (logout?: boolean) => void;
}

export const ProfileEdition: React.SFC<IProfileEditionProps> = ({user,refreshUser,}) => 
  {
    const [state, setState] = React.useState({
      edit: false,
      invalid: false,
      profile: user.profile,
  });

  const toggleEdit = () => {
    setState({ edit: !state.edit, invalid: false, profile: { ...user.profile },});
  };

  const handleChange = (e: React.ChangeEvent<Element>) => {
    setState({...state, profile: {...state.profile, [(e.target as any).name]: (e.target as any).value,},});
  };
  
  /* A optimiser   **********************************************/
  const handleChangeBoolean = (isAvailable : any ) => {

    setState({...state, profile: {...state.profile , isAvailable: !state.profile.isAvailable,  },});
   
  
  };

  const handleChangeMultiFunctionalSkills = (functionalSkills: any) => {
    setState({...state, profile: {...state.profile, functionalSkills}, });
  };

  const handleChangeMultiTechnicalSkills = (technicalSkills: any) => {
    setState({...state, profile: {...state.profile, technicalSkills}, });
  };

  const handleChangeMultiSector = (sector: any) => {
    setState({...state, profile: {...state.profile, sector }, });
  };
/*******  EXPERIENCE ARRAY HANNDLE ******************************************************/
const handleAdd  = () => {
  const experience = state.profile.experience
  experience.push({ title: '', company: '', startDate: null, endDate: null, description: ''});
  setState({...state, profile: {...state.profile, experience},});
};

const handleRemove = (i: any) => {
  if(state.profile.experience.length > 1) {
    const experience = state.profile.experience;
    experience.splice(i, 1);
    setState({...state, profile: {...state.profile, experience},});
  }
  else {
    const experience : any = [...state.profile.experience];
    experience[0].title = ''; experience[0].company = ''; experience[0].startDate = null; experience[0].endDate = null; experience[0].description = '';
    setState({...state, profile: {...state.profile, experience},});
  }
  
};

const handleChangeArray = (e: React.ChangeEvent<Element>) => {
  const experience : any = [...state.profile.experience];
  experience[(e.target as any).id][(e.target as any).name] = (e.target as any).value;
  setState({...state, profile: {...state.profile, experience },});
 };

 const handleDateChangeArray = (date: Date, id: any , name : any) => {
  const experience : any = [...state.profile.experience];
  experience[id][name] = date;
  setState({...state, profile: {...state.profile, experience},});
 };
/**************************************************************************/

/*******  EDUCATION ARRAY HANNDLE ******************************************************/
const handleEducationAdd  = () => {
  const education = state.profile.education
  education.push({  school: '', title: '', startDate: null, endDate: null});
  setState({...state, profile: {...state.profile, education},});
};


const handleEducationRemove = (i: any) => {
  if(state.profile.education.length > 1) {
    const education = state.profile.education;
    education.splice(i, 1);
    setState({...state, profile: {...state.profile, education},});
  }
  else {
    const education : any = [...state.profile.education];
    education[0].school = ''; education[0].title = ''; education[0].startDate = null; education[0].endDate = null;
    setState({...state, profile: {...state.profile, education},});
  }
};

const handleEducationChangeArray = (e: React.ChangeEvent<Element>) => {
  const education : any = [...state.profile. education];
  education[(e.target as any).id][(e.target as any).name] = (e.target as any).value;
  setState({...state, profile: {...state.profile, education },});
 };

 const handleEducationDateChangeArray = (date: Date, id: any , name : any) => {
  const education : any = [...state.profile.education];
  education[id][name] = date;
  setState({...state, profile: {...state.profile, education},});
 };
/**************************************************************************/


/*******  Certification ARRAY HANNDLE ******************************************************/
const handleCertificationAdd  = () => {
  const certification = state.profile.certification
  certification.push({   title: '', obtainDate : null });
  setState({...state, profile: {...state.profile, certification},});
};


const handleCertificationRemove = (i: any) => {
  if(state.profile.certification.length > 1) {
    const certification = state.profile.certification;
    certification.splice(i, 1);
    setState({...state, profile: {...state.profile, certification},});
  }
  else {
    const certification : any = [...state.profile.certification];
    certification[0].title = '';  certification[0].obtainDate = null; 
    setState({...state, profile: {...state.profile, certification},});
  }
};

const handleCertificationChangeArray = (e: React.ChangeEvent<Element>) => {
  const certification : any = [...state.profile. certification];
  certification[(e.target as any).id][(e.target as any).name] = (e.target as any).value;
  setState({...state, profile: {...state.profile, certification },});
 };

 const handleCertificationDateChangeArray = (date: Date, id: any , name : any) => {
  const certification : any = [...state.profile.certification];
  certification[id][name] = date;
  setState({...state, profile: {...state.profile, certification},});
 };
/**************************************************************************/



  const handleDateChange = (date: Date) => {
    setState({...state, invalid: false, profile: { ...state.profile, availableDate: date,},});
  };

  const handleClick = (id: string) => {
    const label = ProjectTypeConfig[id].label;
    const index = state.profile.projectType.indexOf(label);
    const projectType = state.profile.projectType.slice();
    if (index === -1) {
      if (projectType.length < 3) {
        projectType.push(label);
        setState({ ...state,profile: { ...state.profile, projectType },});
      } else {
        setState({ ...state, invalid: true });
      }
    } else {
      if (projectType.length !== 1) {
        projectType.splice(index, 1);
        setState({...state, profile: { ...state.profile, projectType },});
      }
    }
  };

  const handleSave = async () => {
    const { profile } = state;
    const updateUserDto: IUpdateUserDto = { profile, };
    const updatedUser = await updateUser(updateUserDto);
    if (updatedUser) {
      refreshUser();
      setState({ edit: false, invalid: false, profile: updatedUser.profile,});
    }
  };

  return (
    <Form className='p-5'>
      <Row>
        <Col md='12'>
          <span className='text-dark' style={{ fontSize: '32px' }}>
            Mon profil
          </span>
        </Col>
      </Row>

{/****************************************************/}

      <Row className='d-flex justify-content-between mt-3'>
        <Col md='5' xs='auto'>
          <FormGroup>
            <span className='d-block font-weight-bolder mb-2'>Titre</span>
            <Input
              type='text'
              name='title'
              placeholder='Votre métier'
              disabled={!state.edit}
              value={state.profile.title ? state.profile.title : ''}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <span className='d-block font-weight-bolder mb-2'>Pitch</span>
            <Input
              type='textarea'
              name='description'
              placeholder='Présentez-vous en quelques mots'
              disabled={!state.edit}
              value={state.profile.description ? state.profile.description : ''}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <span className='d-block font-weight-bolder mb-3'>
              Domaine d'intervention
            </span>
            <ProjectTypeList
              edit={state.edit}
              projectType={state.profile.projectType}
              handleClick={handleClick}
            />
            <Input invalid={state.invalid} style={{ display: 'none' }} />
            <FormFeedback>
              Vous ne pouvez sélectionner que 3 domaines d'intervention
            </FormFeedback>
          </FormGroup>
          <FormGroup>
            <span className='d-block font-weight-bolder mb-3'>
              Secteurs d'intervention souhaités
            </span>
            <Select
                  name="sector"
                  isDisabled={!state.edit}
                  classNamePrefix="form-control"
                  isMulti={true} 
                  closeMenuOnSelect = {true}
                  options={sectorItems}
                  noOptionsMessage={() => 'Item non disponible'}
                  placeholder='saisir ou selectionner'    
                  value={ state.profile.sector ? state.profile.sector : null}
                  onChange={handleChangeMultiSector}
                />
            </FormGroup>
        </Col>
        <Col md='6' xs='auto'>
          <Row className='d-flex justify-content-between'>
            <Col md='6' xs='auto'>
              <FormGroup>
                <span className='d-block font-weight-bolder mb-2'>
                  Etes vous disponible ?
                </span>
                <CustomInput 
                  disabled={!state.edit} 
                  type="switch" 
                  id="isAvailable" 
                  name="isAvailable"
                  checked={state.profile.isAvailable}
                  onChange={handleChangeBoolean}
                  label={state.profile.isAvailable ? 'Oui' : 'Non'} 
                  />
              </FormGroup>
            </Col>
            <Col md='6' xs='auto'>
              <FormGroup>
                <span className='d-block font-weight-bolder mb-2'>
                  Date de disponibilité
                </span>
                <DateInput
                    edit={state.edit && state.profile.isAvailable}
                    name='availableDate'
                    handleDateChange={handleDateChange}
                    value={!state.profile.isAvailable ? null :
                        (state.profile.availableDate ? new Date(state.profile.availableDate )  : null) }
                    minDate={new Date()}
                    dateFormat='dd/MM/yyyy'
                  />
              </FormGroup>
            </Col>
          </Row>
          <Row className='d-flex justify-content-between'>
            <Col md='6' xs='auto'>
              <FormGroup>
                <span className='d-block font-weight-bolder mb-2'>
                  Tarif jour min
                </span>
                <Input
                  type='text'
                  name='dailyPriceMin'
                  placeholder='€'
                  disabled={!state.edit}
                  value={state.profile.dailyPriceMin ? state.profile.dailyPriceMin : ''}
                  onChange={handleChange}
                  tag={NumberFormat}
                  thousandSeparator={' '}
                  allowNegative={false}
                  isRequired={true}
                  // invalid={state.invalid && !!!state.profile.dailyPriceMin}
                />
                 <FormFeedback>Merci de renseigner un tarif journalier minimun</FormFeedback>
              </FormGroup>
            </Col>
            <Col md='6' xs='auto'>
              <FormGroup>
                <span className='d-block font-weight-bolder mb-2'>
                  Tarif jour max
                </span>
                <Input
                  type='text'
                  name='dailyPriceMax'
                  placeholder='€'
                  disabled={!state.edit}
                  value={state.profile.dailyPriceMax ? state.profile.dailyPriceMax : ''}
                  onChange={handleChange}
                  tag={NumberFormat}
                  thousandSeparator={' '}
                  allowNegative={false}
                />
              </FormGroup>
            </Col>
          </Row>

          <FormGroup>
            <span className='d-block font-weight-bolder mb-2'>
              Compétences fonctionelles
            </span>
            <CreatableSelect 
                  name="functionalSkills"
                  isDisabled={!state.edit}
                  classNamePrefix="form-control"
                  isMulti={true} 
                  closeMenuOnSelect = {true}
                  options={functionalSkillsItems}
                  noOptionsMessage={() => 'Item non disponible'}
                  placeholder='saisir ou selectionner'    
                  value={state.profile.functionalSkills ? state.profile.functionalSkills : null}
                  onChange={handleChangeMultiFunctionalSkills}
                  formatCreateLabel={value => `Ajouter  "${value}"`}
                  createOptionPosition='first'
                  
              />
          </FormGroup>
          <FormGroup>
            <span className='d-block font-weight-bolder mb-2'>
              Compétences techniques
            </span>
            <CreatableSelect
                  name="technicalSkills"
                  isDisabled={!state.edit}
                  classNamePrefix="form-control"
                  isMulti={true} 
                  closeMenuOnSelect = {true}
                  options={technicalSkillsItems}
                  noOptionsMessage={() => 'Item non disponible'}
                  placeholder='saisir ou selectionner'    
                  value={ state.profile.technicalSkills ? state.profile.technicalSkills : null}
                  onChange={handleChangeMultiTechnicalSkills}
                  formatCreateLabel={value => `Ajouter  "${value}"`}
                  createOptionPosition='first'
              />
          </FormGroup>
        </Col>
      </Row>
{/* /***************EXPERIENCE ************************************************************************       */}
       <Row className='d-flex justify-content-between'>
        <Col md='12' xs='auto'>
            <span className='d-block font-weight-bolder mb-2'>Expérience(s) professionnelle(s)</span>
                {state.profile.experience.map((expe , idx) => {
                  return (
                    <div key={`${expe}-${idx}`}>
                      <Row className='d-flex justify-content-between' >
                        <Col md='4' xs='auto'  >
                          <FormGroup  className='toto'>
                            {state.edit && (
                              <Svg width={20} height={20} fill='dark' src='close' onClick={() => handleRemove(`${idx}`)} className='position-absolute'  style={{cursor: 'pointer',left: '6px',top: '-6px', zIndex: 0,}}/>
                            )}              
                            <Input   
                                style={{zIndex: -1}}
                                type='text'
                                id={`${idx}`}
                                name='title'
                                placeholder='Votre poste'
                                disabled={!state.edit}
                                value={expe.title ? expe.title : ''}
                                onChange={handleChangeArray}
                            />
                            </FormGroup>
                          </Col>
                          <Col md='4' xs='auto' >
                            <FormGroup className='toto' >
                                <Input
                                  type='text'
                                  id={`${idx}`}
                                  name='company'
                                  placeholder='Société'
                                  disabled={!state.edit}
                                  value={expe.company ? expe.company : ''}
                                  onChange={handleChangeArray}
                                />
                            </FormGroup>    
                          </Col>
                          <Col md='2' xs='auto' >
                            <FormGroup className='toto'>
                                <DateInput 
                               
                                  edit={state.edit}
                                  id={`${idx}`}
                                  name='startDate'
                                  placeholderText='De'
                                  handleDateChange={handleDateChangeArray}
                                  value={expe.startDate ? new Date(expe.startDate) : null}
                                  showMonthYearPicker={true}
                                  dateFormat='MM/yyyy'
                                  maxDate={expe.endDate ? new Date(expe.endDate) : null }
                                />
                              </FormGroup>  
                            </Col> 
                            <Col md='2' xs='auto' > 
                              <FormGroup className='toto'>
                                <DateInput
                                  edit={state.edit}
                                  id={`${idx}`}
                                  name='endDate'
                                  placeholderText='à'
                                  handleDateChange={handleDateChangeArray}
                                  value={expe.endDate ? new Date(expe.endDate) : null }
                                  showMonthYearPicker={true}
                                  dateFormat='MM/yyyy'
                                  minDate={expe.startDate ? new Date(expe.startDate) : null}
                                />
                              </FormGroup>
                              </Col>
                        </Row>
                    <Row className='mb-2'>
                      <Col md='12' xs='auto'>
                        <FormGroup>
                        <Input
                          type='textarea'
                          id={`${idx}`}
                          name='description'
                          placeholder='Description'
                          disabled={!state.edit}
                          value={expe.description ? expe.description : ''}
                          onChange={handleChangeArray}
                          tag={TextareaAutosize}
                          minRows={3}
                          maxRows={10}
                        />
                    </FormGroup>
                    </Col>
                    </Row> 
                      </div>
                    );
                  })}
                   {state.edit && (
                    <Row className='mb-2' onClick={handleAdd} style={{ opacity: 0.5 }}>
                      <Svg width={24} src='plus'style={{ cursor: 'pointer' }}/>
                      <span className='text-uppercase text-dark ml-2' style={{ cursor: 'pointer' }}>Ajouter une expérience</span>
                    </Row>
                   )}
      
          </Col>
        </Row>            
{/* /*******************************************************************************************************       */}    


{/* /******************EDUCATION *************************************************************************************       */}
       <Row className='d-flex justify-content-between mt-3'>
        <Col md='12' xs='auto'>
          <FormGroup>
            <span className='d-block font-weight-bolder mb-2'>Formation(s)</span>
                {state.profile.education.map((expe , idx) => {
                  return (
                    <div key={`${expe}-${idx}`}>
                      <Row className='d-flex justify-content-between'>
                        <Col md='4' xs='auto'>
                          <FormGroup>
                            {state.edit && (
                              <Svg
                                width={20}
                                height={20}
                                fill='dark'
                                src='close'
                                onClick={() => handleEducationRemove(`${idx}`)}
                                className='position-absolute'
                                style={{cursor: 'pointer',left: '6px',top: '-6px', zIndex: 10,}}
                              />
                            )}              
                              <Input  
                                  type='text'
                                  id={`${idx}`}
                                  name='school'
                                  placeholder='Etablissement'
                                  disabled={!state.edit}
                                  value={expe.school ? expe.school : ''}
                                  onChange={handleEducationChangeArray}
                                />
                            </FormGroup>
                          </Col>
                          <Col md='4' xs='auto'>
                            <FormGroup>                           
                                <Input
                                  type='text'
                                  id={`${idx}`}
                                  name='title'
                                  placeholder='Diplôme'
                                  disabled={!state.edit}
                                  value={expe.title ? expe.title : ''}
                                  onChange={handleEducationChangeArray}
                                />
                            </FormGroup>    
                          </Col>
                          <Col md='2' xs='auto'>
                            <FormGroup>
                                <DateInput 
                                  edit={state.edit}
                                  id={`${idx}`}
                                  name='startDate'
                                  placeholderText='De'
                                  handleDateChange={handleEducationDateChangeArray}
                                  value={expe.startDate ? new Date(expe.startDate) : null }
                                  showMonthYearPicker={true}
                                  dateFormat='MM/yyyy'
                                  maxDate={expe.endDate ? new Date(expe.endDate) : null }
                                />
                              </FormGroup>  
                            </Col> 
                            <Col md='2' xs='auto'> 
                              <FormGroup>
                                <DateInput
                                  edit={state.edit}
                                  id={`${idx}`}
                                  name='endDate'
                                  placeholderText='à'
                                  handleDateChange={handleEducationDateChangeArray}
                                  value={expe.endDate ? new Date(expe.endDate) : null }
                                  showMonthYearPicker={true}
                                  dateFormat='MM/yyyy'
                                  minDate={expe.startDate ? new Date(expe.startDate) : null}
                                />
                              </FormGroup>
                              </Col>
                        </Row>
                      </div>
                    );
                  })}
                   {state.edit && (
                  <Row
                      className='mb-2'
                      onClick={handleEducationAdd}
                      style={{ opacity: 0.5 }}
                    >
                      <Svg
                        width={24}
                        fill='dark'
                        src='plus'
                        style={{ cursor: 'pointer' }}
                      />
                      <span
                        className='text-uppercase text-dark ml-2'
                        style={{ cursor: 'pointer' }}
                      >
                        Ajouter une formation
                      </span>
                    </Row>
                   )}
            </FormGroup>
          </Col>
        </Row>            
{/* /*******************************************************************************************************       */}  


{/* /************************Certification************************************************************       */}
       <Row className='d-flex justify-content-between mt-3'>
        <Col md='12' xs='auto'>
          <FormGroup>
            <span className='d-block font-weight-bolder mb-2'>Certification(s)</span>
                {state.profile.certification.map((expe , idx) => {
                  return (
                    <div key={`${expe}-${idx}`}>
                      <Row className='d-flex justify-content-left'>
                        <Col md='4' xs='auto'>
                          <FormGroup>
                            {state.edit && (
                             <Svg width={20} height={20} fill='dark' src='close' onClick={() => handleCertificationRemove(`${idx}`)} className='position-absolute'  style={{cursor: 'pointer',left: '6px',top: '-6px', zIndex: 10,}}/>
                            )}              
                              <Input  
                                  type='text'
                                  id={`${idx}`}
                                  name='title'
                                  placeholder='Certification'
                                  disabled={!state.edit}
                                  value={expe.title ? expe.title : ''}
                                  onChange={handleCertificationChangeArray}
                                />
                            </FormGroup>
                          </Col>
                          <Col md='2' xs='auto'>
                            <FormGroup>
                                <DateInput 
                                  edit={state.edit}
                                  id={`${idx}`}
                                  name='obtainDate'
                                  placeholderText="Date d'obtention"
                                  handleDateChange={handleCertificationDateChangeArray}
                                  value={expe.obtainDate ? new Date(expe.obtainDate) : null }
                                  showMonthYearPicker={true}
                                  dateFormat='MM/yyyy'
                                />
                              </FormGroup>  
                            </Col> 
                           
                        </Row>
                    
                      </div>
                    );
                  })}
                   {state.edit && (
                  <Row
                      className='mb-2'
                      onClick={handleCertificationAdd}
                      style={{ opacity: 0.5 }}
                    >
                      <Svg
                        width={24}
                        fill='dark'
                        src='plus'
                        style={{ cursor: 'pointer' }}
                      />
                      <span
                        className='text-uppercase text-dark ml-2'
                        style={{ cursor: 'pointer' }}
                      >
                        Ajouter une certification
                      </span>
                    </Row>
                   )}
            </FormGroup>
          </Col>
        </Row>            
{/* /*******************************************************************************************************       */}  
      <Row className='d-flex justify-content-between mt-4'>
        {!state.edit ? (
          <Col md='3'>
            <Button
              className='text-uppercase text-white bg-success border-0'
              onClick={toggleEdit}
            >
              Modifier
            </Button>
          </Col>
        ) : (
          <>
            <Col md='3'>
              <Button
                className='text-uppercase text-white bg-dark border-0'
                onClick={toggleEdit}
              >
                Annuler
              </Button>
            </Col>
            <Col md='3'>
              <Button
                className='text-uppercase text-white bg-success border-0 float-right'
                onClick={handleSave}
              >
                Sauvegarder
              </Button>
            </Col>
          </>
        )}
      </Row>
    </Form>
  );
};



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileEdition.tsx